"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
var owa_session_store_1 = require("owa-session-store");
var owa_options_core_1 = require("owa-options-core");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(legacy_1.action('saveMessageFormatOption')(function saveMessageFormatOption(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, userOptions, serviceObject;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, userOptions = state.userOptions;
                    serviceObject = {};
                    if (optionState.showBcc !== null) {
                        userOptions.AlwaysShowBcc = optionState.showBcc;
                        serviceObject.AlwaysShowBcc = optionState.showBcc;
                    }
                    if (optionState.showFrom !== null) {
                        userOptions.AlwaysShowFrom = optionState.showFrom;
                        serviceObject.AlwaysShowFrom = optionState.showFrom;
                    }
                    if (optionState.composeFormat !== null) {
                        userOptions.ComposeMarkup = optionState.composeFormat;
                        switch (optionState.composeFormat) {
                            case 'Html':
                                serviceObject.DefaultFormat = 0 /* Html */;
                                break;
                            case 'PlainText':
                                serviceObject.DefaultFormat = 1 /* PlainText */;
                                break;
                        }
                    }
                    if (optionState.fontFamily !== null) {
                        userOptions.ComposeFontName = optionState.fontFamily;
                        serviceObject.DefaultFontName = optionState.fontFamily;
                    }
                    if (optionState.fontSize !== null) {
                        userOptions.ComposeFontSize = optionState.fontSize;
                        serviceObject.DefaultFontSize = optionState.fontSize;
                    }
                    if (optionState.isFontBold !== null ||
                        optionState.isFontItalic !== null ||
                        optionState.isFontUnderline !== null) {
                        userOptions.ComposeFontFlags = applyFontFlagIfNonNull(optionState.isFontBold, 1 /* Bold */, userOptions.ComposeFontFlags);
                        userOptions.ComposeFontFlags = applyFontFlagIfNonNull(optionState.isFontItalic, 2 /* Italic */, userOptions.ComposeFontFlags);
                        userOptions.ComposeFontFlags = applyFontFlagIfNonNull(optionState.isFontUnderline, 4 /* Underline */, userOptions.ComposeFontFlags);
                        // For some reason, owa-service has two identical enums, FontFlags and FontFlags2.
                        // Cast one to the other for typechecking
                        serviceObject.DefaultFontFlags = userOptions.ComposeFontFlags;
                    }
                    if (optionState.fontColor !== null) {
                        userOptions.ComposeFontColor = optionState.fontColor;
                        serviceObject.DefaultFontColor = optionState.fontColor;
                    }
                    return [4 /*yield*/, owa_options_core_1.setMailboxMessageConfiguration(serviceObject)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
function applyFontFlagIfNonNull(isFlagSet, flagToSet, collectedFlags) {
    if (isFlagSet === null) {
        return collectedFlags;
    }
    else if (isFlagSet) {
        return collectedFlags | flagToSet;
    }
    else {
        return collectedFlags ^ flagToSet;
    }
}
//# sourceMappingURL=saveMessageFormatOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-message-format-option/lib/actions/saveMessageFormatOption.js
// module id = 5160
// module chunks = 2